module.exports = __webpack_public_path__ + "img/4.0ff47f18.png";